import { render, staticRenderFns } from "./EntityListLayout.vue?vue&type=template&id=56e8374a&scoped=true&"
import script from "./EntityListLayout.vue?vue&type=script&lang=js&"
export * from "./EntityListLayout.vue?vue&type=script&lang=js&"
import style0 from "./EntityListLayout.vue?vue&type=style&index=0&id=56e8374a&lang=scss&scoped=true&"
import style1 from "./EntityListLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8374a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e8374a')) {
      api.createRecord('56e8374a', component.options)
    } else {
      api.reload('56e8374a', component.options)
    }
    module.hot.accept("./EntityListLayout.vue?vue&type=template&id=56e8374a&scoped=true&", function () {
      api.rerender('56e8374a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EntityListLayout.vue"
export default component.exports